import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'

const styles = (theme) => ({
  root: {
    marginTop: '8px',
    marginBottom: '8px'
  }
})

export default withStyles(styles)(TextField)



// WEBPACK FOOTER //
// ./src/components/AddLinkDialog/AddLinkDialogTextField.js